import React, { useState, useEffect } from 'react';

export default function FadeIn({ children, duration = 0.3 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transition: `opacity ${duration}s ease`,
      }}
    >
      {children}
    </div>
  );
}
